/**
 * Pufien — dinamik kargo & tahmini teslim bilgisi.
 *
 * NEDEN JS, NEDEN LIQUID DEĞİL:
 * Shopify CDN sayfaları agresif cache'liyor. Liquid ile "Bugün kargoda" yazsak,
 * 12:00'de cache'lenen sayfa 16:00'da hâlâ "Bugün kargoda" derdi → müşteriye yalan.
 * Bu yüzden hesap TARAYICIDA, sayfa her açıldığında yapılıyor.
 *
 * NEDEN Europe/Istanbul:
 * Kesim saati DEPONUN saati. Ziyaretçi Almanya'daysa kendi saatiyle hesaplamak
 * yanlış olur. Bu yüzden saat dilimi sabit.
 *
 * KURALLAR
 *   Kesim saati       : 13:00 (Europe/Istanbul)
 *   13:00'dan önce    → bugün kargoda
 *   13:00'dan sonra   → ertesi gün kargoda
 *   Hafta sonuna denk gelirse → Pazartesi'ye yuvarlanır
 *     (Cuma 13:00 sonrası "Yarın kargoda" demek YALAN olurdu — yarın Cumartesi.
 *      O yüzden etiket "Pazartesi kargoda" olur.)
 *   Tahmini teslim    : kargo günü + 2 gün
 *     (Pazar'a denk gelirse Pazartesi'ye kaydırılır — Pazar teslimat yok.)
 */
(function () {
  var TZ = 'Europe/Istanbul';
  var CUTOFF_HOUR = 13;
  var DELIVERY_DAYS = 2;

  var DAYS = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];
  var MONTHS = [
    'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
    'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık',
  ];

  /** İstanbul saatiyle "şimdi" — ziyaretçinin saat diliminden bağımsız. */
  function istanbulNow() {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: TZ,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).formatToParts(new Date());

    var get = function (type) {
      var p = parts.find(function (x) { return x.type === type; });
      return p ? parseInt(p.value, 10) : 0;
    };

    // hour12:false bazı tarayıcılarda gece yarısını "24" verir
    var hour = get('hour');
    if (hour === 24) hour = 0;

    return {
      year: get('year'),
      month: get('month'),
      day: get('day'),
      hour: hour,
    };
  }

  function addDays(date, n) {
    var d = new Date(date.getTime());
    d.setDate(d.getDate() + n);
    return d;
  }

  function isWeekend(date) {
    var g = date.getDay();
    return g === 0 || g === 6; // Pazar veya Cumartesi
  }

  function render() {
    var shipEls = document.querySelectorAll('[data-pf-ship]');
    var etaEls = document.querySelectorAll('[data-pf-eta]');
    if (!shipEls.length && !etaEls.length) return;

    var now = istanbulNow();
    // Yalnızca gün aritmetiği yapılacağı için yerel gece yarısı yeterli.
    var today = new Date(now.year, now.month - 1, now.day);

    // --- Kargoya veriliş günü ---
    var ship = new Date(today.getTime());
    if (now.hour >= CUTOFF_HOUR) {
      ship = addDays(ship, 1);
    }
    // Hafta sonuna düştüyse Pazartesi'ye yuvarla
    while (isWeekend(ship)) {
      ship = addDays(ship, 1);
    }

    // --- Etiket ---
    var diffDays = Math.round((ship - today) / 86400000);
    var shipLabel;
    if (diffDays === 0) {
      shipLabel = 'Bugün kargoda';
    } else if (diffDays === 1) {
      shipLabel = 'Yarın kargoda';
    } else {
      // Cuma 13:00 sonrası / hafta sonu → "Pazartesi kargoda"
      shipLabel = DAYS[ship.getDay()] + ' kargoda';
    }

    // --- Tahmini teslim: kargo günü + 2 gün, Pazar'a denk gelirse Pazartesi ---
    var eta = addDays(ship, DELIVERY_DAYS);
    if (eta.getDay() === 0) {
      eta = addDays(eta, 1);
    }
    var etaLabel =
      'Tahmini teslim: ' +
      eta.getDate() + ' ' + MONTHS[eta.getMonth()] + ' ' + DAYS[eta.getDay()];

    shipEls.forEach(function (el) {
      el.textContent = shipLabel;          // alt satır: "Yarın kargoda"
      el.removeAttribute('hidden');
    });
    etaEls.forEach(function (el) {
      el.textContent = etaLabel;           // ana satır: "Tahmini teslim: …"
      el.removeAttribute('hidden');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }

  // Horizon bölümleri morph/section-render ile yeniden çizilebiliyor.
  document.addEventListener('shopify:section:load', render);
})();
